import omitDeep from 'commons/omitDeep';

// Recursively remove all __typename properties from the given object
const removeTypename = object => omitDeep(object, ['__typename']);

export default removeTypename;
